<template>
  <v-card
    @click="$emit('click')"
    style="width: 100%"
    :class="{'mx-auto': true, 'scene-card': true, 'scene-card--active': active }"
  >
    <template slot="progress">
      <v-progress-linear
        color="deep-purple"
        height="10"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-img
      :src="image"
      class="white--text align-end"
      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      height="200px"
    >
      <v-card-title class="pt-0">{{ name }}</v-card-title>
    </v-img>
    <v-chip v-if="isDefault" class="scene-card__chip" color="primary" small>
      Default
    </v-chip>

    <div class="scene-card__menu">
      <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small
                 icon
                 color="white"
                 v-bind="attrs" v-on="on" v-on:click.prevent>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense nav>
          <v-list-item v-if="!isDefault" @click="$emit('on-default')">
            <v-list-item-icon><v-icon>mdi-check-circle-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Set as default</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('on-edit')">
            <v-list-item-icon><v-icon>mdi-file-document-edit-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('on-remove')" class="v-menu--red">
            <v-list-item-icon><v-icon>mdi-delete-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Remove</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SceneCard',
  props: {
    name: String,
    image: String,
    active: Boolean,
    isDefault: Boolean
  }
}
</script>

<style scoped lang="scss">
.scene-card {
  height: 100%;
  transition: all .3s ease;
  overflow: hidden;

  &--active {
    box-shadow: 0 0 0 4px #ffffff !important;
  }

  &:hover {
    text-decoration: none;
  }

  &__chip {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  &__menu {
    position: absolute;
    top: 8px;
    right: 8px;
  }
}
</style>
